import { render, staticRenderFns } from "./table-with-extra-header.vue?vue&type=template&id=0a938b2e&scoped=true&"
import script from "./table-with-extra-header.vue?vue&type=script&lang=js&"
export * from "./table-with-extra-header.vue?vue&type=script&lang=js&"
import style0 from "./table-with-extra-header.vue?vue&type=style&index=0&id=0a938b2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../MultiSiteClient/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a938b2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../MultiSiteClient/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VCol,VIcon,VRow,VSimpleTable})
